import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

interface VerifyOtpRequestData {
  code: string
  password: string
  fromCheckout?: boolean
}

export interface VerifyOtpRequest extends Partial<AxiosRequestConfig> {
  params: VerifyOtpRequestData
}

interface VerifyOtpResponseData extends ResponseData {
  firstName: string
  isEmailVerify: boolean
  message: string
  pmcId: string
  subject: string
  userId: number
  redirectPath?: string
}

export interface VerifyOtpResponse extends AxiosResponse {
  data: VerifyOtpResponseData
}

export function verifySigninOtpAPI(
  { params }: VerifyOtpRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "GET",
    url: `/auth/mobile/verify?otp=${params.code}&fromCheckout=${
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      params?.fromCheckout || false
    }`,
  }) as Promise<VerifyOtpResponse>
}
